
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { EnumMyTabs } from '@xt/client/enums/my'
import { myTabsList } from '@xt/client/dataSource/my/index'
import lodash from 'lodash'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    LazyImg
  }
})
export default class MyTabs extends Vue {
  tabsList: Array<{
    key: EnumMyTabs
    path: string
    display: boolean
    label: string
  }> = myTabsList

  activeTab: EnumMyTabs = EnumMyTabs.Index

  handleChangeTab(key: EnumMyTabs): void {
    if (this.activeTab === key) return

    let path = lodash.get(
      lodash.find(this.tabsList, item => item.key === key),
      'path',
      'my'
    )

    this.$router.push({ name: path })

    document.documentElement.scrollTo({ top: 0 })
  }

  @Watch('$route', { immediate: true, deep: true })
  onRouteChange() {
    const { name } = this.$route

    if (!name) return

    // 路由替换则删除 -2
    let key = lodash.get(
      lodash.find(this.tabsList, item => item.path === name),
      'key',
      EnumMyTabs.Index
    )

    this.activeTab = key as EnumMyTabs
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
